import { render, staticRenderFns } from "./driver_commission.vue?vue&type=template&id=130aa0c6&scoped=true&"
import script from "./driver_commission.vue?vue&type=script&lang=js&"
export * from "./driver_commission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130aa0c6",
  null
  
)

export default component.exports